import {
  LoadingOutlined,
  SearchOutlined,
  CheckSquareFilled,
  CalendarFilled,
  CalculatorFilled,
  FilterFilled,
} from '@ant-design/icons'
import { ColumnType } from 'antd/lib/table'
import { useCallback } from 'react'
import { FilterOptions } from '../types'

/**
 * Creates a resolver for the Ant Design icon associated with each filter type
 * and its loading state.
 */
export function useFilterIcon<T>() {
  return useCallback<(filter: FilterOptions<T>) => ColumnType<T>['filterIcon']>(
    ({ type, loading }) => {
      /*
       * In Ant Design 4, LoadingOutlined visibly wobbles inside a table filter
       * trigger instead of rotating smoothly in place. It still communicates
       * the loading state, and a future Ant Design upgrade may fix the
       * animation.
       */
      if (loading) return <LoadingOutlined />
      else if (type === 'search')
        return (filtered) => (
          <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        )
      else if (type === 'boolean' || type === 'checkboxes')
        return <CheckSquareFilled />
      else if (type === 'date') return <CalendarFilled />
      else if (type === 'number') return <CalculatorFilled />
      else return <FilterFilled />
    },
    []
  )
}
